import styles from './MsrpPrice.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

type MsrpProps = {
  showMsrp?: boolean;
  msrp?: number;
  price?: number;
};

export const MsrpPrice: React.FC<MsrpProps> = ({ showMsrp, msrp, price, ...props }) => {
  const { t } = useTranslation();

  if (!showMsrp || !msrp || !price) {
    return null;
  }
  if (price >= msrp) {
    return null;
  }

  return (
      <span className={styles.msrp} {...props}>{t('msrp', { msrp })}</span>
  );
};
